import React from 'react';
import {
  Button, Flex, HStack, Text,
} from '@chakra-ui/react';
import { FiEyeOff, FiX } from 'react-icons/fi';
import {
  getImpersonatedRoleName, getImpersonatedUserId, getImpersonatedUserName,
  IMPERSONATABLE_ROLES, stopImpersonation,
} from '../utils/impersonation';

// item 323/851 — the unmissable "you are not yourself" indicator while impersonating a role OR a
// specific user: a fixed pill floating bottom-center, everywhere, until EXIT. Deliberately loud
// (solid orange, both skins) — a super-admin must never forget the app is answering as someone else.
const ImpersonationBanner: React.FC = () => {
  const roleName = getImpersonatedRoleName();
  const userId = getImpersonatedUserId();
  if (!roleName && !userId) return null;
  const label = userId
    ? (getImpersonatedUserName() || 'user')
    : (IMPERSONATABLE_ROLES.find((r) => r.value === roleName)?.label ?? roleName ?? '');
  return (
    <Flex
      position="fixed"
      bottom="18px"
      left="50%"
      transform="translateX(-50%)"
      zIndex={2000}
      align="center"
      bg="orange.500"
      color="white"
      borderRadius="full"
      pl={4}
      pr={2}
      py={1.5}
      boxShadow="0 8px 28px rgba(0,0,0,0.45)"
      role="alert"
    >
      <HStack spacing={2}>
        <FiEyeOff />
        <Text fontSize="sm" fontWeight="bold" letterSpacing="0.04em">
          {`VIEWING AS ${label.toUpperCase()}`}
        </Text>
        <Button
          size="xs"
          variant="ghost"
          color="white"
          _hover={{ bg: 'orange.600' }}
          leftIcon={<FiX />}
          onClick={stopImpersonation}
        >
          EXIT
        </Button>
      </HStack>
    </Flex>
  );
};

export default ImpersonationBanner;
